export default __webpack_public_path__ + "files/Phase3_Phase4_common_resources.zip";